import { getToken, getTokenHeader } from '../../../v3/Common/Token';
import {
  dashboardUrl,
  networkInfoDetailUrl,
  networkInfoListUrl,
  poPerformanceDetailsUrl,
} from '../api';
import axios from 'axios';
import { createActionErrorCapture, errorEnvelope } from '../../../utils/sentryUtils';

// PWA-reachable module: capture at the action layer so failures carry a stack
// trace and an error kind, not just a message string from the call site.
const captureActionError = createActionErrorCapture('performance');

export const getPerformanceDataAction = async (payload) => {
  return new Promise(async (next) => {
    const params = new URLSearchParams(payload);
    let token = await getToken();
    await axios
      .get(dashboardUrl, {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'getPerformanceDataAction');
        return next(errorEnvelope(err));
      });
  });
};

export const getNetworkInfoList = async (payload) => {
  return new Promise(async (next) => {
    const params = new URLSearchParams(payload);
    let token = await getToken();
    await axios
      .get(networkInfoListUrl, {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'getNetworkInfoList');
        return next(errorEnvelope(err));
      });
  });
};

export const getNetworkInfoDetails = async (payload) => {
  return new Promise(async (next) => {
    const params = new URLSearchParams(payload);
    let token = await getToken();
    await axios
      .get(networkInfoDetailUrl, {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'getNetworkInfoDetails');
        return next(errorEnvelope(err));
      });
  });
};

export const getPOPerformanceDetails = async (payload) => {
  return new Promise(async (next) => {
    const params = new URLSearchParams(payload);
    let token = await getToken();
    await axios
      .get(poPerformanceDetailsUrl, {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'getPOPerformanceDetails');
        return next(errorEnvelope(err));
      });
  });
};
